
export default {
  props: {
    href: {
      type: String,
      required: true,
    },
  },

  methods: {
    handleClick(event) {
      event.preventDefault()
      this.$nuxt.$emit('global:external-link', this.$props)
    },
  },
}
